module.exports = __webpack_public_path__ + "static/media/arrow_arch_asset.eeacca9b.png";